// extracted by mini-css-extract-plugin
export default {"circle":"cugo39","animated":"k30NmD","color":"GzS30u"};